import { render, staticRenderFns } from "./Personalize.vue?vue&type=template&id=269b320c&scoped=true&"
import script from "./Personalize.vue?vue&type=script&lang=ts&"
export * from "./Personalize.vue?vue&type=script&lang=ts&"
import style0 from "./Personalize.vue?vue&type=style&index=0&id=269b320c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269b320c",
  null
  
)

export default component.exports